import { Menubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { isLoggedIn, clearSession } from "../services/authService";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isConvocatoriaPage = location.pathname === "/convocatoria";
  const isLimpiadorPage = location.pathname === "/Limpiador";
  const isRegistroPage = location.pathname === "/registro";
  const isPersonalPage = location.pathname === "/personal";
  const isConveniosPage = location.pathname === "/convenios";
  const loggedIn = isLoggedIn();

  // ---------- Scroll al formulario ----------
  const scrollToForm = () => {
    const section = document.getElementById("formulario");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTestimonios = () => {
    const section = document.getElementById("testimonios");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const goToTestimonios = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToTestimonios();
      }, 400);
    } else {
      scrollToTestimonios();
    }
  };

  const goToFormulario = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToForm();
      }, 400);
    } else {
      scrollToForm();
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("scroll") === "formulario") {
      setTimeout(() => scrollToForm(), 300);
    }
  }, [location]);

  // ---------- Items del menú ----------
  const items = [
    { label: "Inicio", icon: "pi pi-home", command: () => navigate("/") },
    {
      label: "Formulario",
      icon: "pi pi-envelope",
      command: goToFormulario,
    },
    !isConvocatoriaPage && {
      label: "Quiénes Somos",
      icon: "pi pi-megaphone",
      command: () => navigate("/convocatoria"),
    },
    !isRegistroPage && {
      label: "Registro",
      icon: "pi pi-pencil",
      command: () => navigate("/registro"),
    },
    {
      label: "Testimoniales",
      icon: "pi pi-comments",
      command: goToTestimonios,
    },
    !isPersonalPage && {
      label: "Personal",
      icon: "pi pi-users",
      command: () => navigate("/personal"),
    },
    !isConveniosPage && {
      label: "Convenios",
      icon: "pi pi-id-card",
      command: () => navigate("/convenios"),
    },
    { label: "Otros", icon: "pi pi-ellipsis-h" },
  ].filter(Boolean);

  // ---------- Logo (start) ----------
  const start = (
    <img
      src={`${process.env.PUBLIC_URL}/images/Logo2.png`}
      alt="logo"
      height="40"
      className="mr-2"
      style={{ cursor: "pointer" }}
      onClick={() => navigate("/")}
    />
  );

  // ---------- Login / Logout (end) ----------
  const handleLogout = () => {
    clearSession();
    navigate("/login", { replace: true });
  };

  const end =
    isLimpiadorPage && loggedIn ? (
      <Button
        icon="pi pi-sign-out"
        label="Salir"
        className="p-button-rounded p-button-danger"
        onClick={handleLogout}
      />
    ) : (
      <Button
        icon="pi pi-user"
        label="Login"
        className="p-button-rounded p-button-success"
        onClick={() => navigate("/login")}
      />
    );

  return (
    <div className="navbar-root" style={{ position: "relative", zIndex: 10 }}>
      <Menubar
        model={items}
        start={start}
        end={end}
        style={{
          background: "#ffffff",
          border: "none",
          borderBottom: "1px solid #e2e8f0",
          borderRadius: 0,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      />
    </div>
  );
}
